export default "/images/vendor/flag-icons/flags/1x1/kh.svg?246b79f0e93715351349a02949cb7b97";